var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('GenerateInvoiceValuesPanel',{attrs:{"invoiceTotalValue":_vm.invoiceTotalsPanel(_vm.invoiceListBySale)}}),_vm._v(" "),_c('aAlert',{staticClass:"f12 mb-20",attrs:{"type":"info","message":"Confira todos os dados antes de gerar a fatura.","banner":""}}),_vm._v(" "),_vm._l((_vm.invoiceListBySale),function(sale,i){return _c('div',{key:i},[_c('aTable',{staticClass:"travel-table generate-invoices-table mb-0 relative",staticStyle:{"z-index":"2"},attrs:{"columns":_vm.columns,"data-source":sale,"pagination":false,"footer":false,"scroll":{ y: 800 }},scopedSlots:_vm._u([{key:"sale_id",fn:function(record){return _c('div',{},[_c('aTooltip',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Contrato: "+_vm._s(record.id)+" ")]},proxy:true}],null,true)},[_vm._v("\n          "+_vm._s(record.sale_id)+"\n        ")])],1)}},{key:"product",fn:function(record){return _c('div',{},[_c('div',{staticClass:"dotted-phrase upper"},[_c('a-tooltip',{attrs:{"title":record.product}},[_vm._v("\n            "+_vm._s(record.product)+"\n          ")])],1)])}},{key:"traveller_name",fn:function(record){return _c('div',{},[_c('div',{staticClass:"truncate upper"},[(record.product_type == 'flight')?_c('aTooltip',{attrs:{"placement":"left"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{domProps:{"innerHTML":_vm._s(record.traveller_name)}})]},proxy:true}],null,true)},[_vm._v("\n            "+_vm._s(record.traveller_name)+"\n          ")]):_vm._e(),_vm._v(" "),(['hotel', 'service'].includes(record.product_type))?_c('aTooltip',{attrs:{"placement":"left"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{domProps:{"innerHTML":_vm._s(record.product)}})]},proxy:true}],null,true)},[_vm._v("\n            "+_vm._s(record.product)+"\n          ")]):_vm._e()],1)])}},{key:"incomings",fn:function(record){return _c('div',{},[_c('GenerateInvoiceModalEditRowSection',{attrs:{"contract":record,"editContractId":_vm.editContractId,"column":"incomings"},on:{"onClickChangeEditId":_vm.onClickChangeEditId,"updateContractsList":_vm.updateContractsList}})],1)}},{key:"to_pay",fn:function(record){return _c('div',{},[_c('GenerateInvoiceModalEditRowSection',{attrs:{"contract":record,"editContractId":_vm.editContractId,"column":"to_pay"},on:{"onClickChangeEditId":_vm.onClickChangeEditId,"updateContractsList":_vm.updateContractsList}})],1)}},{key:"ticket_value",fn:function(record){return _c('div',{},[_c('GenerateInvoiceModalEditRowSection',{attrs:{"contract":record,"editContractId":_vm.editContractId,"column":"ticket_value"},on:{"onClickChangeEditId":_vm.onClickChangeEditId,"updateContractsList":_vm.updateContractsList}})],1)}},{key:"ticket_tax_value",fn:function(record){return _c('div',{},[_c('GenerateInvoiceModalEditRowSection',{attrs:{"contract":record,"editContractId":_vm.editContractId,"column":"ticket_tax_value"},on:{"onClickChangeEditId":_vm.onClickChangeEditId,"updateContractsList":_vm.updateContractsList}})],1)}},{key:"extra_fee_value",fn:function(record){return _c('div',{},[_c('GenerateInvoiceModalEditRowSection',{attrs:{"contract":record,"editContractId":_vm.editContractId,"column":"extra_fee_value"},on:{"onClickChangeEditId":_vm.onClickChangeEditId,"updateContractsList":_vm.updateContractsList}})],1)}},{key:"status",fn:function(record){return _c('div',{},[_c('div',{staticClass:"status",attrs:{"id":`contract-${record.id}-invoice-status-${record.product_id}-${record.traveller_id}`}},[_vm._v("\n          ---\n        ")])])}}],null,true)}),_vm._v(" "),_c('aTable',{staticClass:"travel-table generate-invoices-table fw-600 cblack relative",staticStyle:{"margin-top":"-25px","z-index":"1"},attrs:{"columns":[
        {
          title: false,
          dataIndex: 'fakeCol1',
          key: 'fakeCol1',
          width: 70,
        },
        {
          title: false,
          dataIndex: 'fakeCol2',
          key: 'fakeCol2',
          width: 90,
        },
        {
          title: false,
          dataIndex: 'fakeCol3',
          key: 'fakeCol3',
          width: 120,
        },
        {
          title: false,
          dataIndex: 'totalTicket',
          key: 'totalTicket',
          width: 120,
        },
        {
          title: false,
          dataIndex: 'totalTicketTax',
          key: 'totalTicketTax',
          width: 130,
        },
        {
          title: false,
          dataIndex: 'totalIncoming',
          key: 'totalIncoming',
          width: 120,
        },
        {
          title: false,
          dataIndex: 'totalToPay',
          key: 'totalToPay',
          width: 120,
        },

        {
          title: false,
          dataIndex: 'totalExtraFee',
          key: 'totalExtraFee',
          width: 120,
        },
        {
          title: false,
          dataIndex: 'totalBalance',
          key: 'totalBalance',
          width: 100,
        },
      ],"data-source":_vm.totalsListBySale(sale),"header":false,"footer":false,"pagination":false,"scroll":{ y: 800 }}})],1)}),_vm._v(" "),_c('aTable',{staticClass:"travel-table total generate-invoices-table fw-600 cblack relative",staticStyle:{"margin-top":"-10px","z-index":"0","border-bottom":"2px solid #aaa"},attrs:{"columns":[
      {
        title: false,
        dataIndex: 'fakeCol1',
        key: 'fakeCol1',
        width: 160,
      },

      {
        title: false,
        dataIndex: 'fakeCol3',
        key: 'fakeCol3',
        width: 120,
      },
      {
        title: false,
        dataIndex: 'totalTicket',
        key: 'totalTicket',
        width: 120,
      },
      {
        title: false,
        dataIndex: 'totalTicketTax',
        key: 'totalTicketTax',
        width: 130,
      },
      {
        title: false,
        dataIndex: 'totalIncoming',
        key: 'totalIncoming',
        width: 120,
      },
      {
        title: false,
        dataIndex: 'totalToPay',
        key: 'totalToPay',
        width: 120,
      },

      {
        title: false,
        dataIndex: 'totalExtraFee',
        key: 'totalExtraFee',
        width: 120,
      },
      {
        title: false,
        dataIndex: 'totalBalance',
        key: 'totalBalance',
        width: 100,
      },
    ],"data-source":_vm.totalGeneralList(_vm.generalInvoiceList),"header":false,"footer":false,"pagination":false,"scroll":{ y: 800 }}}),_vm._v(" "),_c('GenerateInvoiceForm',{attrs:{"invoiceTotalValue":_vm.invoiceTotalsPanel(_vm.invoiceListBySale),"tempInvoice":_vm.tempInvoice,"generateInvoicesList":_vm.generateInvoicesList},on:{"onFinishGenerateInvoice":_vm.onFinishGenerateInvoice,"onClickIsLoadingAction":_vm.onClickIsLoadingAction}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }